module.exports = __webpack_public_path__ + "img/logo-left.ecab1fd1.png";